import { onBeforeUnmount, onMounted, ref } from 'vue';

const computeIsTouch = (): boolean => {
  if (typeof window === 'undefined') return false;
  // Primary signal (Pointer Events)
  const hasTouchPoints = navigator.maxTouchPoints > 0;
  // Fallback (media query for coarse pointers)
  const isCoarse = window.matchMedia('(pointer: coarse)').matches;
  return hasTouchPoints || isCoarse;
};

export function useIsTouchDevice() {
  const isTouch = ref(false);

  const update = () => {
    setTimeout(() => {
      isTouch.value = computeIsTouch();
      // Optional: expose a CSS hook for styles
      if (typeof document !== 'undefined') {
        document.documentElement.toggleAttribute('data-touch', isTouch.value);
      }
    }, 100);
  };

  onMounted(() => {
    update();
    // Re-evaluate on viewport changes; hybrids can change pointer type
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('orientationchange', update, { passive: true });
  });
  onBeforeUnmount(() => {
    window.removeEventListener('resize', update);
    window.removeEventListener('orientationchange', update);
  });

  return { isTouch };
}
